import React from 'react';

const ProductPlateItemPrice = ({offer, ...props}) => {

  return (
    <>
      {
        offer.price ? (
          offer.new_price ?
            <div className='products-list-item__price' itemProp='offers' itemScope itemType='https://schema.org/Offer'>
              <link href={`https://schema.org/${offer.reminder > 0 ? 'In' : 'OutOf'}Stock`} itemProp='availability' />
              <meta itemProp='priceCurrency' content='RUB' />
              <span className='products-list-item__price-number' itemProp='price' content={offer.new_price}>
                  {offer.new_price_in_format}<span className='products-list-item__price-unit'>/{offer.baseUnit?.name}</span>
                </span>
              <span className='products-list-item__old-price-number'>
                  <span className='decoration-line-through'>{offer.price_in_format}</span>
                </span>
            </div>
            : <>
              <div className='products-list-item__price' itemProp='offers' itemScope itemType='https://schema.org/Offer'>
                <link href={`https://schema.org/${offer.reminder > 0 ? 'In' : 'OutOf'}OfStock`} itemProp='availability' />
                <meta itemProp='priceCurrency' content='RUB' />
                <span className='products-list-item__price-number' itemProp='price' content={offer.price}>
                    {offer.price_in_format}/<span className='products-list-item__price-unit'>{offer.baseUnit?.name}</span>
                  </span>
              </div>
            </>
        ) : null
      }    </>
  );
}

export default ProductPlateItemPrice;
